const { AQL_LEVELS } = require('./aql');
const { genDefectCodes } = require('./defect-code');

const codeValues = {
  'A': { type_desc: 'Appearance',
         codes: ['Stain/Scratch on product',
                 'Torn/folded paper',
                 'Impurity on Barrel',
                 'Flash on product',
                 'Tool mark/creasing/chipping/roughness on product',
                 'Logo/insert sheet printing defect',
                 'Barrel foiling defect',
                 'Embossing defect',
                 'Rust',
                 'Improper Filling',
                 'Product Count Variance']},
  'C': { type_desc: 'Product Checks',
         codes: ['Failed product weight and dimensions check',
                 'Failed writing performance check',
                 'Failed ink leakage check',
                 'Failed drop test',
                 'Failed date code check',
                 'Failed tip press test',
                 'Failed GSM, paper quality or moisture check',
                 'Failed GSM check']},
  'F': { type_desc: 'Functional',
         codes: ['Functional Defect',
                 'Fitting Defect',
                 'Security Pattern']},
  'P': { type_desc: 'Packaging',
         codes: ['Packaging Defect',
                 'Barcode scanning issue (sell unit, inner carton, master carton)',
                 'Dimension and weight issue (sell unit, inner carton, master carton)',
                 'Wrong barcode on product']},
  'S': { type_desc: 'Security',
         codes: ['Unwanted or harmful material']},
};

module.exports = {
  AQL_LEVELS,
  DEFECT_CODES: genDefectCodes(codeValues),
};
